// extracted by extract-css-chunks-webpack-plugin
module.exports = {"renderCaptcha":"ccUag","inputWrapper":"tZjdJ"};